<template>
  <span class="site-loading-mark" aria-hidden="true">
    <img src="/assets/brand/voko-logo.webp" alt="">
    <i></i>
  </span>
</template>

<style scoped>
.site-loading-mark { position: relative; display: grid; width: 72px; height: 72px; place-items: center; }
.site-loading-mark img { display: block; width: 42px; height: 42px; border-radius: var(--drama-radius-md); object-fit: contain; animation: site-loading-breathe 1.15s ease-in-out infinite; }
.site-loading-mark i { position: absolute; inset: 0; border: 2px solid color-mix(in srgb, var(--drama-color-primary) 16%, transparent); border-top-color: var(--drama-color-primary); border-radius: var(--drama-radius-full); animation: site-loading-spin .8s linear infinite; }
@keyframes site-loading-spin { to { transform: rotate(360deg); } }
@keyframes site-loading-breathe { 0%, 100% { opacity: .72; transform: scale(.94); } 50% { opacity: 1; transform: scale(1); } }
@media (prefers-reduced-motion: reduce) { .site-loading-mark img, .site-loading-mark i { animation: none; } }
</style>
